import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { getColor } from '@panel/commons/core/themev3';
import errorNotFoundImage from '@panel/commons/assets/img/error-404.svg';
import errorNotFoundImageUB from '@panel/commons/assets/img/error-404-ub.svg';

const siteId = process.env.REACT_APP_BUILD_SITE;

const PostingNotFound = ({ device, linkToPanel }) => {
  const { t } = useTranslation();
  const redirectPanel = () => {
    window.location.href = `${window.location.origin}${linkToPanel}`;
  };

  return (
    <Container device={device}>
      <NotFoundImage device={device} />
      <ErrorTitle device={device}>{t('panel.desempeno.error.titulo')}</ErrorTitle>
      <ErrorMessage device={device}>{t('panel.desempeno.error.message')}</ErrorMessage>
      <RedirectButton device={device} onClick={redirectPanel}>
        {t('panel.desempeno.error.cta')}
      </RedirectButton>
    </Container>
  );
};
const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding-top: ${({ device }) => device !== 'mobile' && '60px'};
`;
const NotFoundImage = styled.div`
  width: ${({ device }) => (device !== 'mobile' ? '345px' : '228px')};
  height: ${({ device }) => (device !== 'mobile' ? '331px' : '219px')};
  margin-bottom: ${({ device }) => (device !== 'mobile' ? '45px' : '67px')};
  background-image: ${() => {
    if (siteId === 'UBPE') return `url(${errorNotFoundImageUB})`;
    return `url(${errorNotFoundImage})`;
  }};
  background-position: center;
  background-size: cover;
`;
const ErrorTitle = styled.div`
  font-family: 'Hind';
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  margin-bottom: 8px;
  width: ${({ device }) => device === 'mobile' && '308px'};
  text-align: center;
  white-space: pre-wrap;
`;
const ErrorMessage = styled.div`
  font-family: 'Hind';
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  letter-spacing: 0em;
  text-align: center;
  margin-bottom: 32px;
  width: ${({ device }) => (device !== 'mobile' ? '400px' : '250px')};
  white-space: pre-wrap;
`;
const RedirectButton = styled.button`
  background-color: ${getColor('primary')};
  color: white;
  font-family: 'Hind';
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 21px;
  text-align: center;
  min-width: ${({ device }) => (device === 'mobile' ? '263px' : '135px')};
  height: ${({ device }) => (device === 'mobile' ? '48px' : '40px')};
  border-radius: 8px;
  padding: 0 24px;
  cursor: pointer;
  :hover {
    background-color: ${getColor('secondary')};
  }
`;
export default PostingNotFound;
